import * as Sentry from '@sentry/react'

import type { BugReport, BugReportClient } from 'clients/bug-report/interface'

export class SentryBugReportClient implements BugReportClient {
  private readonly enabled: boolean

  constructor(enabled = Boolean(import.meta.env.VITE_SENTRY_DSN)) {
    this.enabled = enabled
  }

  async submit(report: BugReport): Promise<void> {
    if (!this.enabled) return

    Sentry.withScope((scope) => {
      report.screenshots.forEach((screenshot) => {
        scope.addAttachment({
          filename: screenshot.filename,
          data: screenshot.data,
          contentType: screenshot.contentType,
        })
      })
      Sentry.captureFeedback(
        {
          name: report.reporter.name,
          email: report.reporter.email,
          message: report.message,
          url: report.url,
          tags: {
            feedback_type: 'bug',
            feedback_source: 'user',
            feedback_pathname: report.pathname,
            feedback_screenshot_count: String(report.screenshots.length),
            ...report.tags,
          },
        },
        undefined,
        scope,
      )
    })
  }
}
